import { useAtom, useAtomValue } from 'jotai';
import { filePreviewAtom } from 'atoms/file-preview/filePreview';
import { selectedProjectAtom } from 'atoms/projects';
import FileViewerModal from './index';

export const GlobalFileViewerModal = () => {
  const [preview, setPreview] = useAtom(filePreviewAtom);
  const project = useAtomValue(selectedProjectAtom);

  if (!preview) return null;

  return (
    <FileViewerModal
      open
      url={preview.url}
      mimeType={preview.mimeType}
      fileId={preview.fileId}
      project={project || undefined}
      handleClose={() => setPreview(null)}
      expectsFileId
    />
  );
};
